<template>
  <div class="Guides">
    <Guide />
  </div>
</template>

<script>
import Guide from '../components/Guide.vue'

export default {
  name: 'Guides',
  components: {
    Guide
  }
}
</script>